import React from "react";
import Navbar from "../../common/navBar/navBar.tsx";
import Contact from "../contact/contact.tsx";
import Footer from "../../common/footer/footer.tsx";
import About from "../about/about.tsx";
import HeroSection from "../../private/heroSection/heroSection.tsx";
import FAQ from "../faq/faq.tsx";

const Home = () => {
  return (
    <>
      <Navbar />
      <HeroSection />
      <About showNavbar={false} />
      <FAQ showNavbar={false} />
      <Contact showNavbar={false} />
      <Footer />
    </>
  );
};

export default Home;
